// Generated by scripts/generate-version.js — do not edit by hand.
export const APP_VERSION = '1.8.34';
export const GIT_SHA = '21ce864';
